// extracted by mini-css-extract-plugin
var _1 = "colored-tag___gSALo";
var _2 = "remove-button___o0HIs";
export { _1 as "colored-tag", _2 as "remove-button" }
